<template>
    <div>
        <BlockUI v-if="busy">
            <div class="loader"></div>
        </BlockUI>
        <div class="pointer" @click="trigger()">
            <slot name="header">
                <h6>...Upload File</h6>
            </slot>
            <input ref="uploadFile" type="file" accept=".xls,.xlsx" @change="onChange" @click="reset()" hidden />
        </div>
    </div>
</template>
<script>
import { readExcel }  from '@/helpers/excelGenerator'
export default {
    name: 'ImportRateExcel',
    data(){
        return {
            busy: false,
            file: null,
            data: []
        }
    },
    methods:{
        trigger(){
          this.$refs.uploadFile.click()
        },
        reset () {
            this.$refs.uploadFile.value = ''
        },
        async onChange( event ){
            this.isLoading()
            try{
                const json = await this.convertExcelToJson( event )
                this.$emit( 'onSuccess', this.convertResponseSuccess(json) )
            }catch( e ){
                // เดะกลับมาหาทำ
            }
            this.isLoaded()

        },
        convertResponseSuccess( data ){
            return {
                status: true,
                data: data
            }
        },
        isLoading(){
            this.busy = true
        },
        isLoaded(){
            this.busy = false
        },
        convertExcelToJson( event ) {
            return readExcel(event.target.files[0])
        }
    }
}
</script>
<style lang="scss" scoped>
.pointer {
    cursor: pointer;
    &:hover {
       opacity: 0.5;
    }
}
</style>